import React from 'react'
import { Card } from 'semantic-ui-react'
import { Container, Row, Col } from 'react-bootstrap'



class Kard extends React.Component {
    render() {
        const isi = [
            {
                header: 'Freelance - Front End Developer',
                description: 'simple website creation services such as portfolios, blogs and more',
                meta: 'Agust 2018 - Present | Padang, West Sumatera',
            },
            {
                header: 'Freelance - Graphic Designer',
                description: 'mock up services for marketing products such as Web user interface, banners, logos, pamphlets, brochures, and social media content.',
                meta: 'June 2017 - Present | Padang, West Sumatera ',
            },
            {
                header: 'Content Creator - Awak Tour & Travel agency',
                description: 'making marketing content such as banner brochures, logo, posters, concurrently as a social media admin and Local Tour Guide.',
                meta: 'March 2017 - February 2018 | Padang, West Sumatera',
            },
            {
                header: 'Sales Agent - PT KISEL',
                description: 'sell Telkomsel products to several regional outlets, and inform the excellence of the latest products and services.',
                meta: 'June 2012 - December 2013 | Padang, West Sumatera'
            }
        ]
        return (
            <div>
                <Container>
                    <Row xs={6}>
                        <Col >
                            <Card.Group centered items={isi} />
                        </Col>
                    </Row>
                </Container>
                <br />
            </div>
        )
    }
};



export default Kard;